module.exports = {"623021100":"城关镇","623021101":"新城镇","623021102":"冶力关镇","623021103":"羊永镇","623021104":"王旗镇","623021105":"古战镇","623021106":"洮滨镇","623021107":"八角镇","623021108":"流顺镇","623021109":"店子镇","623021110":"羊沙镇","623021200":"术布乡","623021202":"卓洛乡","623021203":"长川乡","623021208":"三岔乡","623021210":"石门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623021.json
// module id = 2972
// module chunks = 0